import React, { useState } from "react"

import Sidebar from "../sidebar/sidebar"
import LogoComponent from "../logo";
import "./layout.css"
import HamburgerComponent from "../hamburger";

const Layout = ({ children, categories, currentCategory, currentPage }) => {
  const [sidebarVisible, setSidebarVisible] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarVisible(!sidebarVisible);
  };

  return (
    <div className="wrapper container-sito pt-4">
      <div className="mb-4 header-nav">
        <div className="header-nav-logo">
          <LogoComponent />
        </div>
        <div className="header-nav-button">
          <div onClick={handleSidebarToggle} className={`header-nav-button bubble-text ${sidebarVisible ? "bubble-text-selected" : ""}`}>
            <HamburgerComponent />
          </div>
        </div>
      </div>
      <div className="d-flex">
        <Sidebar siteTitle="EmojiGalaxy" categories={categories} currentCategory={currentCategory} currentPage={currentPage} visible={sidebarVisible} />
        <main className={`main ${sidebarVisible ? "main-slide-sidebar" : "main-slide-sidebar-none"}`}>{children}</main>
      </div>
    </div>
  )
}

export default Layout
